import { render } from "./groups.vue?vue&type=template&id=3caefe81&scoped=true"
import script from "./groups.vue?vue&type=script&lang=js"
export * from "./groups.vue?vue&type=script&lang=js"

import "./groups.vue?vue&type=style&index=0&id=3caefe81&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3caefe81"]])

export default __exports__